import React from 'react'
import Control from './control'
import Paper from '@material-ui/core/Paper'
import { RowDetailState } from '@devexpress/dx-react-grid'
import {
  Grid,
  Table,
  TableRowDetail,
  TableColumnResizing
} from '@devexpress/dx-react-grid-material-ui'
import { Container } from 'reactstrap'

class ControlGrid extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      columns: [
        { name: 'category', title: 'Category' }
      ],
      columnWidths: [
        { columnName: 'category', width: 850 }
      ],
      rows: [{}],
      update: true
    }

    this.changeExpandedDetails = expandedRowIds => this.setState({ expandedRowIds })
    this.changeColumnWidths = (columnWidths) => {
      this.setState({ columnWidths })
    }
  }

  shouldComponentUpdate (nextProps, nextState) {
    if ((this.props.selectedCatName && nextProps.selectedCatName) &&
      (this.props.selectedCatName.name !== nextProps.selectedCatName.name)) {
      return true
    } else {
      return this.props.update
    }
  }

  componentDidUpdate (prevProps, prevState) {
    let rows
    if (prevProps.categories !== this.props.categories) {
      rows = this.props.categories.map(category => {
        if (category) {
          // console.log('set update to false')
          // this.setState({ update: false })
          this.props.setUpdate(true, true)
          return {
            category: category.name.toUpperCase(),
            number: category.controlsTotal,
            compliance: ((category.compliantControlsTotal / category.controlsTotal) * 100).toFixed(2),
            originalCategory: category.name
          }
        } else {
          return 'N/A'
        }
      })
      this.setState({ rows })
    } else {
      // this.setState({ update: true })
    }
  }

  componentDidMount () {
    this.props.setUpdate(true, false)
  }

  RowDetail () {
    return <Control title='Vendor Assessment' {...this.props} />
  };

  render () {
    const { rows, columns, columnWidths } = this.state
    // console.log(rows)
    return (
      <Container>
        <Paper>
          <Grid
            rows={rows}
            columns={columns}
          >
            <RowDetailState
              defaultExpandedRowIds={[0]}
            />
            <Table />
            <TableColumnResizing
              columnWidths={columnWidths}
              onColumnWidthsChange={this.changeColumnWidths}
            />
            {/* <TableHeaderRow /> */}
            <TableRowDetail
              contentComponent={this.RowDetail.bind(this)}
            />
          </Grid>
        </Paper>
      </Container>
    )
  }
}

export default ControlGrid



// WEBPACK FOOTER //
// ./src/components/vendor_assessments/controlGrid.js